import {Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'la-checkbox',
  template: `
    <label class="la-checkbox">
      <ng-content></ng-content>
      <input type="checkbox" (click)="onClick()" [disabled]="isDisabled" [checked]="isChecked">
      <span class="la-checkbox__check-mark" [ngClass]="{
      'la-checkbox__check-mark--disabled': isDisabled,
      'la-checkbox__check-mark--checked': isChecked,
      'la-checkbox__check-mark--checkedAndDisabled': isChecked && isDisabled}">
      </span>
    </label>
  `,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-checkbox{position:relative;display:inline;padding-left:33px;margin-bottom:12px;font-size:15px;font-weight:500;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.la-checkbox input{position:absolute;opacity:0}.la-checkbox input:checked~.la-checkbox__check-mark{background-color:#fff}.la-checkbox input:checked~.la-checkbox__check-mark:after{display:block}.la-checkbox:hover input~.la-checkbox__check-mark{border:1px solid rgba(3,20,34,.3);background-color:rgba(3,20,34,.05)}.la-checkbox__check-mark{position:absolute;top:-2px;left:0;width:25px;height:25px;background-color:#fff;border-radius:4px;border:1px solid rgba(3,20,34,.2);cursor:pointer}.la-checkbox__check-mark--disabled{border:1px solid rgba(3,20,34,.2);background-color:rgba(3,20,34,.05);opacity:.4;cursor:not-allowed}.la-checkbox__check-mark--checked{background-color:#23be9e!important;border:1px solid #23be9e!important}.la-checkbox__check-mark--checked:hover{background-color:#00846a!important;border:1px solid #00846a!important}.la-checkbox__check-mark--checkedAndDisabled{background-color:#23be9e!important;border:1px solid #23be9e!important;opacity:.4;cursor:not-allowed}.la-checkbox__check-mark--checkedAndDisabled:hover{background-color:#23be9e!important;border:1px solid #23be9e!important}.la-checkbox__check-mark:after{position:absolute;display:none;content:"";top:5px;left:9px;width:6px;height:12px;border:1px solid #fff;border-width:0 2px 2px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}
  `],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LaCheckboxComponent),
    multi: true
  }],
  encapsulation: ViewEncapsulation.None
})
export class LaCheckboxComponent implements ControlValueAccessor {

  @Output() onChecked: EventEmitter<any> = new EventEmitter();
  @Output() onCheckedObj: EventEmitter<any> = new EventEmitter();
  onChange: any = Function.prototype;
  onTouched: any = Function.prototype;
  private _selectedValue: any = true;

  private _isChecked = false;

  get isChecked(): boolean {
    return this._isChecked;
  }

  @Input()
  set isChecked(value: boolean) {
    this._isChecked = value;
  }

  private _isDisabled = false;

  get isDisabled(): boolean {
    return this._isDisabled;
  }

  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  private _value: any;

  get value(): any {
    return this._value;
  }

  @Input()
  set value(value: any) { // value used for object, array, and simple string
    this._value = value;
  }

  onClick(): void {
    if (this.isDisabled) {
      return; // if control is disabled. no need to perform any action
    }
    this.isChecked = !this.isChecked;
    let value;
    if (this.isChecked) {
      value = this._selectedValue;
    } else {
      // checking a type if value is boolean and checkbox unchecked
      // return false value other vise return empty string
      if (typeof this._selectedValue === 'string') {
        value = '';
      } else if (typeof this._selectedValue === 'number' || typeof this._selectedValue === 'object') {
        value = null;
      } else if (Array.isArray(this._selectedValue)) {
        value = [];
      } else {
        value = false;
      }
    }
    this.propagateChange(value);
    this.onChecked.emit(value);
  }

  /* code for value accessor start */
  writeValue(value: any): void {
    this._selectedValue = this.value;
    if (value) {
      this.isChecked = true;
    }

    if (!this.value && value) {
      this._selectedValue = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  propagateChange = (_: any) => {
  };
  /* code for value accessor end */
}
